import { render, staticRenderFns } from "./editdropdown.vue?vue&type=template&id=1cbd8d80&"
import script from "./editdropdown.vue?vue&type=script&lang=js&"
export * from "./editdropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports